unit View.Login;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Controls, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,
  XData.Web.Connection, WEBLib.ExtCtrls,
  App.Types,
  ConnectionModule,
  XData.Web.Client,
  JS,
  View.Dialog,
  WEBLib.WebCtrls,
  UUtils, UWeb.Enum;

type
  TFViewLogin = class(TForm)
    lblTituloPagina: TLabel;
    edUser: TEdit;
    btLogin: TButton;
    lbMessage: TLabel;
    lbLogando: TLabel;
    imgLogando: TImageControl;
    lblEsqueciSenha: TLabel;
    btnRecuperarSenha: TButton;
    XDataClientRecuperarSenha: TXDataWebClient;
    edPassword: TEdit;
    lblLogar: TLabel;
    imgLogin: TImageControl;
    procedure btLoginClick(Sender: TObject);
    procedure WebButton1Click(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure edUserKeyPress(Sender: TObject; var Key: Char);
    procedure edPasswordKeyPress(Sender: TObject; var Key: Char);
    procedure lblEsqueciSenhaClick(Sender: TObject);
    procedure btnRecuperarSenhaClick(Sender: TObject);
    procedure edtEmailClick(Sender: TObject);
    procedure XDataClientRecuperarSenhaError(Error: TXDataClientError);
    procedure XDataClientRecuperarSenhaLoad(Response: TXDataClientResponse);
    procedure lblLogarClick(Sender: TObject);
  private
    FLoginProc: TSuccessProc;
    FMessage: string;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    procedure MostrarOcultarLogando(pMostrar : Boolean);
    function ValidarMensagemErroLogin(pMensagem : string) : string;
  public
    class procedure Display(AElementId: string; LoginProc: TSuccessProc); overload;
    class procedure Display(AElementId: string; LoginProc: TSuccessProc;
      AMsg: string); overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewLogin: TFViewLogin;

implementation

uses
  Auth.Service,
  View.ErrorPage;

{$R *.dfm}

procedure TFViewLogin.btLoginClick(Sender: TObject);

  procedure LoginSuccess;
  begin
    FLoginProc;
  end;

  procedure LoginError(AMsg: string);
  var
    lMensagemErro : string;
  begin
    lMensagemErro := AMsg.Replace('Unauthorized:', '');
    MostrarOcultarLogando(False);

    lMensagemErro := ValidarMensagemErroLogin(lMensagemErro);

    ShowNotification(lMensagemErro);
  end;

begin
  lbMessage.Visible := False;

  if Trim(eduser.Text).IsEmpty or Trim(edPassword.Text).IsEmpty then
  begin
    MostrarOcultarLogando(False);
    ShowNotification('Entre com seu email e senha!');
    Exit;
  end;

  if not TUtils.ValidarEmail(eduser.Text) then
  begin
    MostrarOcultarLogando(False);
    ShowNotification('Email inválido');

    Exit;
  end;

  MostrarOcultarLogando(True);

  AuthService.Login(
    edUser.Text, edPassword.Text,
    @LoginSuccess,
    @LoginError
  );
end;

class procedure TFViewLogin.Display(AElementId: string; LoginProc: TSuccessProc);
begin
  TFViewLogin.Display(AElementId, LoginProc, '');
end;

procedure TFViewLogin.btnRecuperarSenhaClick(Sender: TObject);
begin
  lbMessage.Visible := False;

  if not TUtils.ValidarEmail(eduser.Text) then
  begin
    MostrarOcultarLogando(False);
    ShowNotification('Email inválido');

    Exit;
  end;

  MostrarOcultarLogando(True);


  XDataClientRecuperarSenha.RawInvoke('ILoginService.RecuperarSenha', [eduser.Text]);
end;

class procedure TFViewLogin.Display(AElementId: string; LoginProc: TSuccessProc;
  AMsg: string);

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewLogin(AForm).FMessage := AMsg;
    TFViewLogin(AForm).FLoginProc := LoginProc;
  end;

begin
  if Assigned(FViewLogin) then
    FViewLogin.Free;
  FViewLogin := TFViewLogin.CreateNew(AElementId, @AfterCreate);
end;

procedure TFViewLogin.edUserKeyPress(Sender: TObject; var Key: Char);
begin
  if Key = #13 then
    edPassword.SetFocus;
end;

procedure TFViewLogin.edPasswordKeyPress(Sender: TObject; var Key: Char);
begin
  if Key = #13 then
    btLogin.Click;
end;

procedure TFViewLogin.edtEmailClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('view_login_form_lbemail');
end;

procedure TFViewLogin.HiddenNotification;
begin
  lbMessage.Visible := False;
end;

procedure TFViewLogin.lblEsqueciSenhaClick(Sender: TObject);
begin
  edUser.Text := '';
  TUtils.OcultarElemento('divSenha');
  TUtils.OcultarElemento('lblEsqueciSenha');
  TUtils.OcultarElemento('btnLogin');
  TUtils.MostrarElemento('lblLogar');
  TUtils.MostrarElemento('btnRecuperarSenha');

  lblTituloPagina.Caption := 'Recuperação de senha';
  lbLogando.Caption := 'Aguarde';
  lbMessage.Visible := False;
  MostrarOcultarLogando(False);
end;

procedure TFViewLogin.lblLogarClick(Sender: TObject);
begin
  edUser.Text := '';
  TUtils.OcultarElemento('lblLogar');
  TUtils.OcultarElemento('btnRecuperarSenha');
  TUtils.MostrarElemento('divSenha');
  TUtils.MostrarElemento('lblEsqueciSenha');
  TUtils.MostrarElemento('btnLogin');

  lblTituloPagina.Caption :='Faça login para continuar';
  lbLogando.Caption := 'Logando';
  lbMessage.Visible := False;
  MostrarOcultarLogando(False);
end;

procedure TFViewLogin.MostrarOcultarLogando(pMostrar: Boolean);
begin
  btLogin.Enabled := not pMostrar;
  btnRecuperarSenha.Enabled := not pMostrar;
  lbLogando.Visible := pMostrar;
  imgLogando.Visible := pMostrar;
end;

procedure TFViewLogin.ShowNotification(Notification: string);
begin
  if Notification <> '' then
  begin
    lbMessage.Visible := True;
    lbMessage.Caption := Notification;
  end;
end;

function TFViewLogin.ValidarMensagemErroLogin(pMensagem: string): string;
begin
  Result := pMensagem;

  if Pos('inativo/bloqueado', pMensagem.ToLower) > 0 then
    Result := 'Usuário Inativo/Bloqueado'
  else if Pos('aguardando validação', pMensagem.ToLower) > 0 then
    Result := 'Usuário Aguardando validação de email'
  else if Pos('inativo!', pMensagem.ToLower) > 0 then
    Result := 'Aliado inativo!'
  else if Pos('suspenso/congelado!', pMensagem.ToLower) > 0 then
    Result := 'Aliado Suspenso/Congelado!';
end;

procedure TFViewLogin.WebButton1Click(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewLogin.WebFormCreate(Sender: TObject);
begin
  if DMConnection.FServidor = TServidor.SERVICE then
    imgLogin.url := 'assets/img/logo-facil.svg'
  else if DMConnection.FServidor = TServidor.WHATSAPP then
    imgLogin.url := 'assets/img/img_login.png';

  MostrarOcultarLogando(False);

  if FMessage <> '' then
    ShowNotification(FMessage)
  else
    HiddenNotification;
end;

procedure TFViewLogin.XDataClientRecuperarSenhaError(Error: TXDataClientError);
begin
  MostrarOcultarLogando(False);
  ShowNotification(ValidarMensagemErroLogin(Error.ErrorMessage));
end;

procedure TFViewLogin.XDataClientRecuperarSenhaLoad(
  Response: TXDataClientResponse);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Um link para redefinir a senha foi enviado para o email informado!');
  MostrarOcultarLogando(False);
  lblLogar.OnClick(nil);
end;

procedure TFViewLogin.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lblTituloPagina := TLabel.Create('view.login.title');
  lbMessage := TLabel.Create('view.login.message.label');
  lbLogando := TLabel.Create('label_aguardando');
  imgLogando := TImageControl.Create('gif-carregando');
  lblEsqueciSenha := TLabel.Create('lblEsqueciSenha');
  lblLogar := TLabel.Create('lblLogar');
  imgLogin := TImageControl.Create('imgLogin');
  edUser := TEdit.Create('usuario');
  btLogin := TButton.Create('btnLogin');
  btnRecuperarSenha := TButton.Create('btnRecuperarSenha');
  edPassword := TEdit.Create('view.login.edpassword');
  XDataClientRecuperarSenha := TXDataWebClient.Create(Self);

  lblTituloPagina.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  lbLogando.BeforeLoadDFMValues;
  imgLogando.BeforeLoadDFMValues;
  lblEsqueciSenha.BeforeLoadDFMValues;
  lblLogar.BeforeLoadDFMValues;
  imgLogin.BeforeLoadDFMValues;
  edUser.BeforeLoadDFMValues;
  btLogin.BeforeLoadDFMValues;
  btnRecuperarSenha.BeforeLoadDFMValues;
  edPassword.BeforeLoadDFMValues;
  XDataClientRecuperarSenha.BeforeLoadDFMValues;
  try
    Name := 'FViewLogin';
    Width := 640;
    Height := 480;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lblTituloPagina.SetParentComponent(Self);
    lblTituloPagina.Name := 'lblTituloPagina';
    lblTituloPagina.Left := 240;
    lblTituloPagina.Top := 112;
    lblTituloPagina.Width := 121;
    lblTituloPagina.Height := 13;
    lblTituloPagina.Caption := 'Fa'#231'a login para continuar';
    lblTituloPagina.HeightPercent := 100.000000000000000000;
    lblTituloPagina.Transparent := False;
    lblTituloPagina.WidthPercent := 100.000000000000000000;
    lbMessage.SetParentComponent(Self);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 280;
    lbMessage.Top := 221;
    lbMessage.Width := 3;
    lbMessage.Height := 13;
    lbMessage.HeightPercent := 100.000000000000000000;
    lbMessage.WidthPercent := 100.000000000000000000;
    lbLogando.SetParentComponent(Self);
    lbLogando.Name := 'lbLogando';
    lbLogando.Left := 24;
    lbLogando.Top := 288;
    lbLogando.Width := 41;
    lbLogando.Height := 13;
    lbLogando.Caption := 'Logando';
    lbLogando.HeightPercent := 100.000000000000000000;
    lbLogando.WidthPercent := 100.000000000000000000;
    imgLogando.SetParentComponent(Self);
    imgLogando.Name := 'imgLogando';
    imgLogando.Left := 24;
    imgLogando.Top := 307;
    imgLogando.Width := 100;
    imgLogando.Height := 41;
    imgLogando.HeightPercent := 100.000000000000000000;
    imgLogando.WidthPercent := 100.000000000000000000;
    imgLogando.ChildOrder := 6;
    lblEsqueciSenha.SetParentComponent(Self);
    lblEsqueciSenha.Name := 'lblEsqueciSenha';
    lblEsqueciSenha.Left := 368;
    lblEsqueciSenha.Top := 288;
    lblEsqueciSenha.Width := 92;
    lblEsqueciSenha.Height := 13;
    lblEsqueciSenha.Caption := 'Esqueceu a senha?';
    lblEsqueciSenha.HeightPercent := 100.000000000000000000;
    lblEsqueciSenha.WidthPercent := 100.000000000000000000;
    SetEvent(lblEsqueciSenha, Self, 'OnClick', 'lblEsqueciSenhaClick');
    lblLogar.SetParentComponent(Self);
    lblLogar.Name := 'lblLogar';
    lblLogar.Left := 368;
    lblLogar.Top := 269;
    lblLogar.Width := 55;
    lblLogar.Height := 13;
    lblLogar.Caption := 'Fazer Login';
    lblLogar.HeightPercent := 100.000000000000000000;
    lblLogar.WidthPercent := 100.000000000000000000;
    SetEvent(lblLogar, Self, 'OnClick', 'lblLogarClick');
    imgLogin.SetParentComponent(Self);
    imgLogin.Name := 'imgLogin';
    imgLogin.Left := 24;
    imgLogin.Top := 112;
    imgLogin.Width := 100;
    imgLogin.Height := 41;
    imgLogin.HeightPercent := 100.000000000000000000;
    imgLogin.WidthPercent := 100.000000000000000000;
    imgLogin.ChildOrder := 11;
    edUser.SetParentComponent(Self);
    edUser.Name := 'edUser';
    edUser.Left := 240;
    edUser.Top := 136;
    edUser.Width := 121;
    edUser.Height := 21;
    edUser.HeightPercent := 100.000000000000000000;
    edUser.TextHint := 'Digite o email';
    edUser.WidthPercent := 100.000000000000000000;
    SetEvent(edUser, Self, 'OnKeyPress', 'edUserKeyPress');
    btLogin.SetParentComponent(Self);
    btLogin.Name := 'btLogin';
    btLogin.Left := 240;
    btLogin.Top := 216;
    btLogin.Width := 121;
    btLogin.Height := 25;
    btLogin.Caption := 'Login';
    btLogin.HeightPercent := 100.000000000000000000;
    btLogin.TabOrder := 2;
    btLogin.WidthPercent := 100.000000000000000000;
    SetEvent(btLogin, Self, 'OnClick', 'btLoginClick');
    btnRecuperarSenha.SetParentComponent(Self);
    btnRecuperarSenha.Name := 'btnRecuperarSenha';
    btnRecuperarSenha.Left := 368;
    btnRecuperarSenha.Top := 335;
    btnRecuperarSenha.Width := 121;
    btnRecuperarSenha.Height := 25;
    btnRecuperarSenha.Caption := 'Recuperar Senha';
    btnRecuperarSenha.ChildOrder := 9;
    btnRecuperarSenha.HeightPercent := 100.000000000000000000;
    btnRecuperarSenha.TabOrder := 2;
    btnRecuperarSenha.WidthPercent := 100.000000000000000000;
    SetEvent(btnRecuperarSenha, Self, 'OnClick', 'btnRecuperarSenhaClick');
    edPassword.SetParentComponent(Self);
    edPassword.Name := 'edPassword';
    edPassword.Left := 240;
    edPassword.Top := 179;
    edPassword.Width := 121;
    edPassword.Height := 21;
    edPassword.ChildOrder := 10;
    edPassword.HeightPercent := 100.000000000000000000;
    edPassword.PasswordChar := '*';
    edPassword.TabOrder := 1;
    edPassword.TextHint := 'Digite a senha';
    edPassword.WidthPercent := 100.000000000000000000;
    SetEvent(edPassword, Self, 'OnKeyPress', 'edPasswordKeyPress');
    XDataClientRecuperarSenha.SetParentComponent(Self);
    XDataClientRecuperarSenha.Name := 'XDataClientRecuperarSenha';
    XDataClientRecuperarSenha.Connection := DMConnection.AuthConnection;
    SetEvent(XDataClientRecuperarSenha, Self, 'OnLoad', 'XDataClientRecuperarSenhaLoad');
    SetEvent(XDataClientRecuperarSenha, Self, 'OnError', 'XDataClientRecuperarSenhaError');
    XDataClientRecuperarSenha.Left := 360;
    XDataClientRecuperarSenha.Top := 392;
  finally
    lblTituloPagina.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    lbLogando.AfterLoadDFMValues;
    imgLogando.AfterLoadDFMValues;
    lblEsqueciSenha.AfterLoadDFMValues;
    lblLogar.AfterLoadDFMValues;
    imgLogin.AfterLoadDFMValues;
    edUser.AfterLoadDFMValues;
    btLogin.AfterLoadDFMValues;
    btnRecuperarSenha.AfterLoadDFMValues;
    edPassword.AfterLoadDFMValues;
    XDataClientRecuperarSenha.AfterLoadDFMValues;
  end;
end;

end.
